__turbopack_context__.v({
  "arrow": "_4KBuLa_arrow",
  "arrowLeft": "_4KBuLa_arrowLeft",
  "arrowRight": "_4KBuLa_arrowRight",
  "stage": "_4KBuLa_stage",
  "wrap": "_4KBuLa_wrap",
});
